
import { Component, Watch, Vue } from 'vue-property-decorator';
import { Action, Mutation, State } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import {
  getProductInfo,
  addCart,
  productNaturePrice,
  addressList,
  saveAddress,
  getFreight,
  getEvaluatelist,
  followEvaluate,
  pageVisit,
  getIntegralExchangeDetail,
  getDataBanner,
  getDataReCommend,
  getDataProType,
  getBargainGoodsDetails,
  startBargain,
  getPreferenCoupon,
  receiveCoupon,
  popularizeList,
  popularizeReceive,
  popularizeClose,
  auto_receive_coupon,
  calc_price,
  browser_history,
  marketingActivityDetails
} from '@/services/http';
import {
  readCookie,
  dateFormatter,
  dateTimeFormatter,
  writeStorage
} from '@/tools/tools';
import { validateTelPhone } from '@/tools/regexp';
import moment from 'moment';
import * as _ from 'lodash';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import Regular from '@/components/regular/index.vue';
import addData from '../../assets/json/address.json';

// declare let swfobject: any;
@Component({
  components: {
    Price,
    Header,
    Footer,
    BackTop,
    Regular
  },
  filters: {
    dotDate(value: string) {
      if (!value) return '';
      const d = new Date(value);
      return `${d.getFullYear()}.${d.getMonth() + 1}.${d.getDate()}`;
    }
  }
})
export default class extends Vue {
    isLoading: boolean = false // 基础信息

    basicList: any[] = [] // 基础信息

    foldName: string = '展开' // 基础信息展开/收起

    activeName: string = 'first' // 标签页

    maxNum: number = 99999 // 最大选择数量

    imgurl: any[] = [] // 轮播图片列表

    imgUrlList: any[] = []

    selectArr: any[] = [] // 所选规格列表

    selectId: string = ''

    rulesDescription: string = ''

    // 是否是耗材
    isConsumables: boolean = false

    // 总条数
    totalnumber: number = 10

    // 当前页数
    currentpage: number = 1

    // 服务说明
    productServiceName: any = []

    pageNo: number = 1

    realDiscountStatusly: boolean = false

    realDiscountPrice: string = '' // 到手价

    realdiscountPriceShow: string = '' // 活动商品金额展示

    pageSize: number = 10

    showDialogBack: boolean = false

    address: string = '请选择'

    options: any[] = []

    cityOptions: any[] = []

    areaOptions: any[] = []

    // 导航分类名称
    typeName: string = ''

    // 地址列表
    addressList: any = []

    receiveAddress: any = []

    addIndex: number = 0

    isLogin: boolean = readCookie('accessToken')

    value: any[] = []

    ruleForm: any = {
      realName: '',
      cityId: '',
      cityName: '',
      areaId: '',
      areaName: '',
      address: '',
      area: '',
      telephone: '',
      defaultAddress: 0,
      provinceId: '',
      provinceName: '',
      addressTemp: ''
    }

    isAddressSelect: boolean = false

    rules: object = {
      realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
      telephone: [
        { required: true, validator: validateTelPhone, trigger: 'blur' }
      ],
      areaId: [
        {
          required: true,
          message: '请选择地址'
        }
      ],
      addressTemp: [
        { required: true, message: '请输入详细地址', trigger: 'blur' }
      ]
    }

    // 换货地址id
    addressid: string = ''

    // 登录运费显示
    freightPrice: string = '包邮'

    // 导航分类id
    productType: string = ''

    naturelist: any[] = [] // 规格列表

    //  是否展示运费规则
    isFreightDrop: boolean = false

    // 选中价格
    selectPrice: string = ''

    // 选中划线价
    selectMarkPrice: string = ''

    imgFirst: string = '' // 规格尺寸弹窗图片（取轮播图第一张）

    // 运费
    freightwords: string = ''

    val: number = 1 // 所选商品数量

    productlist: any = [] // 购物车列表

    priceList: any[] = [] // 价格列表

    // 选中重量
    weight: string = ''

    // 部分城市运费规则
    somecities: string = ''

    otherFree: boolean = false

    // 包邮
    shipping: [] = []

    // 其他城市运费规则
    othercities: [] = []

    // 是否下架
    isshelf: boolean = false

    // 当前等级
    level: boolean = false

    evaluateList: any[] = []

    mySwiper: any = ''

    showPlay: boolean = true

    controls: boolean = false

    bar1: any = 0 // 当前进度

    bar2: any = 0 // 总进度

    volume: any = 0 // 音量

    currentTime: any = 0 // 当前播放时间 00: 00

    duration: any = 0 // 总时长 00:00

    receiveCouponly: any = false // 是否领取优惠卷

    totalTime: number = 0

    isVideo: boolean = false

    showCloseVideo: boolean = false

    activeImg: number = 0

    exchangeInfo: object = {} // 积分兑换信息

    bargainInfo: object = {} // 砍价信息

    countdown: object = { hour: '00', minute: '00', second: '00' }

    dialogVisible: boolean = false

    serviceDialog: boolean = false

    endSecond: number = 3

    couponDialog: boolean = false

    totalPrice: number = 0

    isCoupon: boolean = false

    couponText: string = '' // 优惠券满多少减多少

    couponLoading: boolean = false

    couponList: any[] = []
    promoTags: any[] = []

    promoActivities: any[] = []

    promoLoading: boolean = false

    // 促销条倒计时：目标时间戳（ms），来自 calc_price；无倒计时则为 0
    promoCountdownTargetAt: number = 0

    // 倒计时语义：toStart 距活动开始，toEnd 距活动结束
    promoCountdownMode: string = 'toEnd'

    // 促销条活动名称/标签文案
    promoCountdownLabel: string = ''

    // 完整倒计时文案（含前缀），供无障碍或备用展示
    promoCountdownText: string = ''

    // 活动 banner 是否展示（由 calc_price 的 activityStatus / ruleType / showCountDown 映射）
    showPromoBanner: boolean = false

    // 到手价 badge 文案：'活动开始后到手价' | '满件折扣-到手价' | '到手价' | ''
    promoPriceBadge: string = ''

    // 剩余天数（整块天，与时分秒拆分展示）
    promoCountdownDays: number = 0

    promoCountdownHH: string = '00' // 剩余小时（两位）

    promoCountdownMM: string = '00' // 剩余分钟（两位）

    promoCountdownSS: string = '00' // 剩余秒（两位）

    promoCountdownTimer: any = null // setInterval 句柄，离开页或结束时需清理

    // 首购特惠
    isFirstBuy: boolean = false

    isSmallSale: boolean = false

    // 开屏推广大图
    appSourceUrl: string = ''

    // 开屏推广小图
    smallSourceUrl: string = ''

    isShowSale: boolean = false // 限时抢购弹窗

    flashSaleId: string = ''

    isFLash: boolean = false

    giftMap: any = {}

    @Action('card/setCardNum') setCardNum!: Function

    @State('card') cardstate: any

    @Action('white/setWhiteStauts') setWhiteStauts!: Function

    @Mutation('order/CONFIRMORDER') CONFIRMORDER!: Function

    // 浏览商品记录埋点
    handData() {
      /// 浏览商品记录
      browser_history({
        productId: this.priceList[0].productId, // 商品编号
        productPriceId: this.priceList[0].id // 商品价格编码
      }).then((res) => { });
    }

    async created() {
      await this.getNaturePrice();
      await this.addressLists();
      await this.pageVisit();
      await this.getPopularizeList();
      sessionStorage.removeItem('integralInfo');
      await this.handData();
    }

    beforeDestroy() {
      this.clearPromoCountdown();
    }

    // 获取促销活动列表
    async fetchPromoActivities() {
      this.promoLoading = true;
      const res: any = await marketingActivityDetails({
        productId: this.productlist.id,
        productPriceId: this.selectId
      });
      if (res.data.code === 100) {
        this.promoActivities = res.data.data;
      }
      this.promoLoading = false;
    }

    // 开启促销条 1s 轮询；fetchPromoHeader 判定有未到期目标时间后调用，重复调用会先清旧定时器
    startPromoCountdown() {
      this.clearPromoCountdown();
      this.formatPromoCountdown();
      this.promoCountdownTimer = setInterval(() => {
        this.formatPromoCountdown();
      }, 1000);
    }

    // 清除促销倒计时定时器；beforeDestroy、倒计时归零或重新 start 时调用
    clearPromoCountdown() {
      if (this.promoCountdownTimer) {
        clearInterval(this.promoCountdownTimer);
        this.promoCountdownTimer = null;
      }
    }

    // 按目标时间戳用 moment 计算剩余天/时分秒，更新拆分字段与 promoCountdownText；由定时器每秒触发
    formatPromoCountdown() {
      if (!this.promoCountdownTargetAt) {
        this.promoCountdownText = '';
        return;
      }
      const remaining = this.promoCountdownTargetAt - Date.now();
      if (remaining <= 0) {
        this.promoCountdownText = '';
        this.promoCountdownDays = 0;
        this.clearPromoCountdown();
        return;
      }
      const duration = moment.duration(remaining);
      const days = Math.floor(duration.asDays());
      const hh = String(duration.hours()).padStart(2, '0');
      const mm = String(duration.minutes()).padStart(2, '0');
      const ss = String(duration.seconds()).padStart(2, '0');
      this.promoCountdownDays = days;
      this.promoCountdownHH = hh;
      this.promoCountdownMM = mm;
      this.promoCountdownSS = ss;
      const prefix = this.promoCountdownMode === 'toStart' ? '距离开始还剩' : '距离结束还剩';
      this.promoCountdownText = days > 0
        ? `${prefix} ${days}天 ${hh}:${mm}:${ss}`
        : `${prefix} ${hh}:${mm}:${ss}`;
    }

    // 显示优惠券列表
    async showCoupon() {
      this.couponDialog = true;
      this.couponLoading = true;
      this.fetchPromoActivities();
      try {
        const res: any = await getPreferenCoupon({
          productId: (this as any).$route.query.id,
          companyId: 1
        });
        if (res.data.code === 100) {
          this.couponList = this.normalizeCouponList(res.data.data || []);
        }
      } catch (e) {
        this.couponList = [];
      } finally {
        this.couponLoading = false;
      }
    }

    private normalizeCouponList(list: any[]): any[] {
      return list.map((item: any) => ({
        ...item,
        useStartDate: dateTimeFormatter(item.useStartDate),
        useEndDate: dateTimeFormatter(item.useEndDate)
      }));
    }

    couponDateText(item: any): string {
      const startsAt = item.useStartDate ? new Date(item.useStartDate).getTime() : 0;
      return startsAt > Date.now()
        ? `${item.useStartDate} 开始可用`
        : `有效期至：${item.useEndDate}`;
    }

    handTips() {
      (this as any).$refs.RegularRef.dialogVisible = true;
    }

    // 领取优惠券
    async receiveCoupon(item: any) {
      if (item.receive) return;
      const res: any = await receiveCoupon({
        couponId: item.id,
        productId: this.$route.query.id
      });
      if (res.data.code === 100) {
        this.$message.success('领取成功');
        this.showCoupon();
      } else {
        this.$message.error(res.data.message);
      }
    }

    // 时间格式化
    private timer(seconds: number) {
      let minute: any = Math.floor(seconds / 60);
      if (minute < 10) {
        minute = `0${minute}`;
      }

      let second: any = Math.floor(seconds % 60);
      if (second < 10) {
        second = `0${second}`;
      }
      return `${minute}:${second}`;
    }

    // 初始化音量
    private initVolume() {
      this.volume = this.volume === 0 ? 35 : 0;
    }

    // 播放-暂停
    private playPause() {
      if (this.showPlay) {
        this.play();
        this.isVideo = true;
        this.showCloseVideo = true;
      } else {
        this.pause();
        this.showCloseVideo = false;
      }
    }

    // 视频关闭
    private closeVideo() {
      this.isVideo = false;
      this.showPlay = true;
      this.showCloseVideo = false;
    }

    // 进度条拖动
    private changeBar1() {
      this.currentTime = this.timer(this.bar1);
    }

    // 视频播放
    private play() {
      this.isVideo = true;
      this.showCloseVideo = true;
      // this.isUseVideo();
      this.$nextTick(() => {
        const myVideo: any = (this as any).$refs.video
                // 当前播放时间
                ; (this as any).currentTime = this.timer(myVideo.currentTime);
        (this as any).duration = this.timer(myVideo.duration); // 总时长
        this.totalTime = myVideo.duration;
        this.bar1 = (myVideo.currentTime / myVideo.duration).toFixed(2); // 当前进度
        this.bar2 = 100 - this.bar1; // 总长度
        myVideo.play();
        // 监听播放开始
        myVideo.addEventListener('play', () => {
          this.controls = true;
          this.showPlay = false;
          this.showCloseVideo = true;
        });
        // 监听播放暂停
        myVideo.addEventListener('pause', () => {
          this.showPlay = true;
        });
        // 监听播放结束
        myVideo.addEventListener('ended', () => {
          this.closeVideo();
        });
        // 监听播放时间
        myVideo.addEventListener(
          'timeupdate',
          () => {
            if (myVideo.duration === myVideo.currentTime) this.closeVideo();
            (this as any).currentTime = this.timer(myVideo.currentTime); // 当前播放时间
            this.bar1 = ((myVideo.currentTime / myVideo.duration) * 100).toFixed(
              2
            );
            this.bar2 = 100 - this.bar1;
          },
          false
        );
      });
    }

    // 视频暂停
    private pause() {
      (this as any).$refs.video[0].pause();
      this.controls = true;
      this.showPlay = true;
    }

    // 获取商品评价列表
    private async getEvaList() {
      let productId: any = this.$route.query.id;
      if (
        this.$route.query.type === 'integral'
            || this.$route.query.type === 'bargain'
      ) {
        productId = this.$route.query.product_id;
      }
      const res: any = await getEvaluatelist({
        productId,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      if (res.data.code === 100) {
        this.totalnumber = res.data.data.total;
        this.evaluateList = res.data.data.list.map((item: any) => {
          const data = item;
          data.create_time = dateFormatter(item.create_time);
          data.bigFlag = false;
          data.bigImg = '';
          data.bigIndex = -1;
          data.imageList = data.imageList.map((list: any) => {
            const sub = list;
            sub.activeIndex = -1;
            return sub;
          });
          return data;
        });
      }
    }

    // 打开大图
    private openBig(index: number, img: string, idx: number) {
      this.evaluateList[index].bigFlag = true;
      this.evaluateList[index].bigImg = img;
      this.evaluateList[index].bigIndex = idx;
      this.evaluateList[index].imageList = this.evaluateList[index].imageList.map(
        (item: any) => {
          const data = item;
          data.activeIndex = -1;
          return data;
        }
      );
      this.evaluateList[index].imageList[idx].activeIndex = idx;
    }

    // 关闭大图
    private closeBig(index: number) {
      this.evaluateList[index].bigFlag = false;
      this.evaluateList[index].imageList = this.evaluateList[index].imageList.map(
        (item: any) => {
          const data = item;
          data.activeIndex = -1;
          return data;
        }
      );
    }

    // 上一张大图
    private prevBig(index: number, activeIndex: number) {
      // index 当前订单下标（用于修改大图路径）
      // activeIndex 当前订单图片选择的下标（用于修改小图选择框）
      if (activeIndex <= 0) return;
      this.evaluateList[index].bigImg = this.evaluateList[index].imageList[activeIndex - 1].cdnFilePathPc;
      this.evaluateList[index].imageList[activeIndex - 1].activeIndex = activeIndex - 1;
      this.evaluateList[index].bigIndex = activeIndex - 1;
      this.evaluateList[index].imageList[activeIndex].activeIndex = -1;
    }

    // 下一张大图
    private nextBig(index: number, activeIndex: number, length: number) {
      // index 当前订单下标（用于修改大图路径）
      // activeIndex 当前订单图片选择的下标（用于修改小图选择框）
      if (activeIndex >= length) return;
      this.evaluateList[index].bigImg = this.evaluateList[index].imageList[activeIndex + 1].cdnFilePathPc;
      this.evaluateList[index].imageList[activeIndex + 1].activeIndex = activeIndex + 1;
      this.evaluateList[index].bigIndex = activeIndex + 1;
      this.evaluateList[index].imageList[activeIndex].activeIndex = -1;
    }

    // 对评价点赞
    async dianzan(evaluateId: number, follow: number, index: number) {
      const status: number = follow === 1 ? 0 : 1;
      this.evaluateList[index].follow = status;
      this.evaluateList[index].following = status === 1
        ? this.evaluateList[index].following + 1
        : this.evaluateList[index].following - 1;
      await followEvaluate({ evaluateId, status });
    }

    hangcChange(e: any) {
      this.refreshCalcPrice(Number(e));
    }

    // 统一调用 calc_price：回填到手价与活动 banner 状态
    private refreshCalcPrice(num: number) {
      calc_price({
        productId: this.productlist.id,
        productPriceId: this.selectId,
        companyId: 1,
        num
      }).then((res: any) => {
        const d = res.data.data;
        this.totalPrice = d.realDiscountPrice;
        this.realdiscountPriceShow = d.realdiscountPriceShow;
        this.promoTags = [];
        if (d.discountActivityTag) this.promoTags.push({ label: d.discountActivityTag });
        if (d.giftActivityTag) this.promoTags.push({ label: d.giftActivityTag });
        if (d.marketingActivity) {
          this.applyPromoFromCalc(d.marketingActivity);
        }
        this.giftMap = d.giftMap || {};
      });
    }

    // calc_price 响应 → banner / 倒计时状态映射
    private applyPromoFromCalc(d: any) {
      const activityStatus = Number(d.activityStatus);
      const ruleType = Number(d.ruleType);
      const showCountDown = Number(d.showCountDown);
      const countdownEndTime = Number(d.countdownEndTime);
      // 满赠或非预告/进行中 → 不展示 banner
      if (ruleType === 4 || (activityStatus !== 1 && activityStatus !== 2)) {
        this.showPromoBanner = false;
        this.promoPriceBadge = '';
        this.promoCountdownLabel = '';
        this.promoCountdownTargetAt = 0;
        this.promoCountdownText = '';
        this.clearPromoCountdown();
        return;
      }
      this.showPromoBanner = true;
      this.promoCountdownLabel = d.activityTag;
      if (activityStatus === 1) {
        this.promoCountdownMode = 'toStart';
        this.promoPriceBadge = '活动开始后到手价';
        this.promoCountdownTargetAt = countdownEndTime;
        this.startPromoCountdown();
        return;
      }

      // activityStatus === 2 进行中
      this.promoCountdownMode = 'toEnd';
      this.promoPriceBadge = '到手价';
      if (showCountDown === 1) {
        this.promoCountdownTargetAt = countdownEndTime;
        this.startPromoCountdown();
      } else {
        this.promoCountdownTargetAt = 0;
        this.promoCountdownText = '';
        this.clearPromoCountdown();
      }
    }

    private fold(): void {
      if (this.foldName === '展开') {
        this.basicList = this.productlist.specsList;
        this.foldName = '收起';
      } else {
        this.basicList = this.productlist.specsList.slice(0, 8);
        this.foldName = '展开';
      }
    }

    get freight(): Object {
      const { addressid, selectId } = this;
      return {
        addressid,
        selectId
      };
    }

    @Watch('freight')
    private onFreightChange(newval: any) {
      if (newval.addressid !== '' && newval.selectId !== '') {
        this.getFreight();
      }
    }

    get galleryThumbs() {
      return (this as any).$refs.galleryThumbs.swiper;
    }

    get galleryTop() {
      return (this as any).$refs.galleryTop.swiper;
    }

    triggerBanner() {
      // const $this = this;
      this.mySwiper = new Swiper('.gallery-top', {
        autoplay: 0,
        spaceBetween: 0,
        initialSlide: 0,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        // pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        noSwiping: true,
        noSwipingClass: 'stop-swiping'
        // paginationClickable: true,
        // onSlideChangeEnd(swiper: any) {
        //   this.activeImg = swiper.activeIndex;
        //   if ($this.isVideo && ($this as any).$refs.video) {
        //     ($this as any).$refs.video.pause();
        //     this.showPlay = true;
        //   }
        // }
      });
      const galleryTop = this.mySwiper;
      const galleryThumbs = new Swiper('.gallery-thumbs', {
        initialSlide: 0,
        spaceBetween: 16,
        loopedSlides: 4,
        slidesPerView: 5,
        slideToClickedSlide: true,
        allowTouchMove: false
        // onTap() {
        //   galleryTop.slideTo(galleryThumbs.clickedIndex);
        // }
      });
      galleryTop.params.control = galleryThumbs;
      galleryThumbs.params.control = galleryTop;
    }

    slidePrev() {
      this.galleryThumbs.slidePrev();
      this.activeImg = this.mySwiper.activeIndex;
    }

    slideNext() {
      this.galleryThumbs.slideNext();
      this.activeImg = this.mySwiper.activeIndex;
    }

    onMouseEnter(index: number) {
      this.activeImg = index;
      if (this.isVideo) return;
      this.galleryTop.slideTo(index, 1000, false);
    }

    //  从购物车进来
    private setNature() {
      if (this.$route.query.productPriceId) {
        const { productPriceId } = this.$route.query;
        const arr: any[] = [];
        const priceList = this.priceList.filter(
          (e: any) => e.id === Number(productPriceId)
        );
        priceList[0].natureIds
          .split(',')
          .map(Number)
          .forEach((value: any, index: any) => {
            const obj = {
              index,
              id: value,
              natureName: this.naturelist[index].data.filter(
                (e: any) => e.id === value
              )[0].natureName,
              natureValue: this.naturelist[index].data.filter(
                (e: any) => e.id === value
              )[0].natureValue
            };
            arr.push(obj);
          });
        this.selectArr = arr;
        this.val = this.$route.query.tag ? (this.cardstate.cardList[0]?.num ?? 1) : 1;
        this.selectPrice = String(priceList[0].price);
        this.selectMarkPrice = String(priceList[0].originalPrice);
        this.weight = this.priceList[0].weight;
        this.selectId = String(productPriceId);
        this.realDiscountStatusly = this.priceList[0].realDiscountStatus;
        this.realDiscountPrice = this.priceList[0].realDiscountPrice;
        this.realdiscountPriceShow = this.priceList[0].realdiscountPriceShow;
        this.refreshCalcPrice(this.val);
      }
    }

    // 获取商品规格价格
    private async getNaturePrice() {
      let productId: any = this.$route.query.id;
      if (
        this.$route.query.type === 'integral'
            || this.$route.query.type === 'bargain'
      ) {
        productId = this.$route.query.product_id;
      }
      const res: any = await productNaturePrice({
        productId,
        companyId: 1
      });
      this.naturelist = res.data.data.nature;
      this.priceList = res.data.data.price;
      await this.getBannerList();
      this.setNature();
    }

    private setData() {
      if (!this.$route.query.productPriceId) {
        const arr: any[] = [];
        if (this.priceList.length > 0) {
          this.priceList[0].natureIds
            .split(',')
            .map(Number)
            .forEach((value: any, index: any) => {
              const obj = {
                index,
                id: value,
                natureName: this.naturelist[index].data.filter(
                  (e: any) => e.id === value
                )[0].natureName,
                natureValue: this.naturelist[index].data.filter(
                  (e: any) => e.id === value
                )[0].natureValue
              };
              arr.push(obj);
            });
        }
        this.selectArr = arr;
        this.selectId = this.priceList[0].id;
        this.selectPrice = String(this.priceList[0].price);
        this.selectMarkPrice = String(this.priceList[0].originalPrice);
        this.weight = this.priceList[0].weight;
        this.realDiscountStatusly = this.priceList[0].realDiscountStatus;
        this.realDiscountPrice = this.priceList[0].realDiscountPrice;
        this.refreshCalcPrice(this.val);

        if (this.selectArr[0].mallImage) {
          this.imgurl = [
            { cdnFilePathPc: this.selectArr[0].mallImage.cdnFilePathH5 }
          ];
        } else {
          this.imgurl = this.productlist.headPics;
        }
      }
    }

    formatCountdown(result: any) {
      (this as any).countdown.hour = Math.floor(result / 3600) < 10
        ? `0${Math.floor(result / 3600)}`
        : Math.floor(result / 3600);
      (this as any).countdown.minute = Math.floor((result / 60) % 60) < 10
        ? `0${Math.floor((result / 60) % 60)}`
        : Math.floor((result / 60) % 60);
      (this as any).countdown.second = Math.floor(result % 60) < 10
        ? `0${Math.floor(result % 60)}`
        : Math.floor(result % 60);
    }

    goBargain() {
      this.$router.push({ name: 'bargain' });
    }

    // 获取商品详情信息
    async getBannerList() {
      let res: any = {};
      if (this.$route.query.type === 'integral') {
        // 积分兑换商品详情
        this.isLoading = true;
        res = await getIntegralExchangeDetail({ id: this.$route.query.id });
        if (res.data.data.surplus <= 0) {
          this.$message.error('该商品活动已结束~即将前往积分兑换页面');
          setTimeout(() => {
            this.isLoading = false;
            this.$router.push('/integral');
          }, 3000);
          return;
        }
        this.isLoading = false;
        this.exchangeInfo = res.data.data.config ? res.data.data.config : {}; // 积分兑换信息
      } else if (this.$route.query.type === 'bargain') {
        // 砍价商品详情
        this.isLoading = true;
        res = await getBargainGoodsDetails({
          bargainProductId: this.$route.query.id
        });
        let surplus: any = 0;
        if (res.data.code === 100) {
          if (res.data.data.surplus <= 0) {
            this.$message.error('该商品活动已结束~即将前往砍价活动页面');
            setTimeout(() => {
              this.isLoading = false;
              this.$router.push('/bargain');
            }, 3000);
            return;
          }
          this.bargainInfo = res.data.data.mallBargainProduct
            ? res.data.data.mallBargainProduct
            : {}; // 砍价信息
          surplus = res.data.data.surplus;
          this.formatCountdown(surplus);
          surplus -= 1;
          this.isLoading = false;
        }
        if (surplus > 0) {
          const timer = setInterval(() => {
            if (surplus <= 0) {
              clearInterval(timer);
              this.dialogVisible = true;
              const timer2 = setInterval(() => {
                if (this.endSecond <= 1) {
                  clearInterval(timer2);
                  this.dialogVisible = false;
                  this.goBargain();
                  return;
                }
                this.endSecond -= 1;
              }, 1000);
              return;
            }
            this.formatCountdown(surplus);
            surplus -= 1;
          }, 1000);
        }
      } else {
        // 正常商品详情
        const anchor = readCookie('anchor');
        res = await getProductInfo({
          productId: this.$route.query.id,
          model: anchor ? anchor.model : '',
          equipMeid: anchor ? anchor.equipMeid : '',
          src: anchor ? (anchor.src ? anchor.src : 2) : 4,
          equip: anchor ? anchor.equip : 4,
          version: anchor ? anchor.version : '',
          companyId: 1
        });
      }
      this.productlist = res.data.data.product;
      this.isCoupon = res.data.data.isCoupon;
      const { couponList } = res.data.data;
      if (this.isCoupon) {
        this.couponText = `券满${couponList[0].fullReduce}减${couponList[0].reduceMoney}`;
      }
      this.isFirstBuy = res.data.data.isFirstBuy;
      this.productServiceName = res.data.data.productServiceName;
      this.basicList = res.data.data.product.specsList.slice(0, 8);
      this.level = res.data.data.level;
      this.typeName = res.data.data.product.typeStr;
      this.productType = res.data.data.product.productType;
      this.isConsumables = res.data.data.product.consumables === 1;
      this.receiveCouponly = res.data.data.receiveCoupon;
      (this as any).$refs.backTopRef.setScrollDom(this.productlist);
      if (!this.isConsumables) {
        if (!this.$route.query.productPriceId) {
          const arr: any[] = [];
          if (this.priceList.length > 0) {
            this.priceList[0].natureIds
              .split(',')
              .map(Number)
              .forEach((value: any, index: any) => {
                const obj = {
                  index,
                  id: value,
                  natureName: this.naturelist[index].data.filter(
                    (e: any) => e.id === value
                  )[0].natureName,
                  natureValue: this.naturelist[index].data.filter(
                    (e: any) => e.id === value
                  )[0].natureValue
                };
                arr.push(obj);
              });
          }
          this.selectArr = arr;
          if (this.priceList.length > 0) {
            this.selectPrice = String(this.priceList[0].price);
            this.selectMarkPrice = String(this.priceList[0].originalPrice);
            this.weight = this.priceList[0].weight;
            this.selectId = this.priceList[0].id;
            this.realDiscountStatusly = this.priceList[0].realDiscountStatus;
            this.realDiscountPrice = this.priceList[0].realDiscountPrice;
            this.refreshCalcPrice(this.val);
          }
        }

        this.imgurl = res.data.data.product.headPics;
        this.imgUrlList = res.data.data.product.headPics;
      } else {
        this.setData();
      }
      this.imgFirst = res.data.data.product.listImagePath.cdnFilePathPc;
      this.isshelf = res.data.data.product.status === 0;
      this.freightwords = res.data.data.product.freeFreight === 0 ? '包邮（部分地区不包邮)' : '包邮';
      // eslint-disable-next-line max-len
      this.rulesDescription = res.data.data.mallLogisticsTemplate
        ? `首重每${res.data.data.mallLogisticsTemplate.firstWeight}公斤${res.data.data.mallLogisticsTemplate.firstWeightPrice}元，续重每公斤${res.data.data.mallLogisticsTemplate.continuousWeightPrice}元`
        : '';
      // eslint-disable-next-line max-len
      this.otherFree = res.data.data.mallLogisticsTemplate
            && res.data.data.mallLogisticsTemplate.firstWeight === 0
            && res.data.data.mallLogisticsTemplate.firstWeightPrice === 0
            && res.data.data.mallLogisticsTemplate.continuousWeightPrice === 0;
      if (
        res.data.data.mallLogisticsTemplate
            && res.data.data.mallLogisticsTemplate.appointFree === 0
            && res.data.data.mallLogisticsTemplate.pointLogisticsTemplates.length !== 0
      ) {
        const arr = res.data.data.mallLogisticsTemplate.pointLogisticsTemplates;
        this.othercities = arr.map((element: any) => ({
          name: `${element.cities}:首重每${element.firstWeight}公斤${element.firstWeightPrice}元，续重每${element.continuousWeight}公斤${element.continuousWeightPrice}元`
        }));
      } else {
        const free = res.data.data.mallLogisticsTemplate
                && res.data.data.mallLogisticsTemplate.freeLogisticsTemplates;
        if (free) {
          this.shipping = free.map((element: any) => ({
            name:
                        // eslint-disable-next-line no-nested-ternary
                        element.freeCondition === 1
                          ? `${element.freeCities}:${element.freeWeight}公斤以内包邮`
                          : element.freeCondition === 2
                            ? `${element.freeCities}:超过${element.freePrice}元包邮`
                            : `${element.freeCities}:${element.freeWeight}公斤以内超过${element.freePrice}元包邮`
          }));
        }
        if (res.data.data.mallLogisticsTemplate) {
          const arr = res.data.data.mallLogisticsTemplate.pointLogisticsTemplates;
          this.othercities = arr.map((element: any) => ({
            name: `${element.cities}:首重每${element.firstWeight}公斤${element.firstWeightPrice}元，续重每${element.continuousWeight}公斤${element.continuousWeightPrice}元`
          }));
        }
      }
      setTimeout(() => {
        this.triggerBanner();
      });
      // if (this.isLogin) this.getEvaList();
      this.getEvaList();
    }

    // 总金额计算
    // get totalPrice(): number {
    //   let totalSum = 0
    //   if (this.realDiscountStatusly) {
    //     totalSum += _.multiply(Number(this.selectPrice), this.val)
    //   } else {
    //     totalSum += _.multiply(Number(this.realDiscountPrice), this.val)
    //   }

    //   return _.round(totalSum, 2)
    // }

    selectNature(obj: any, index: number) {
      const { id, natureValue, natureName } = obj;
      const target = {
        id,
        index,
        natureValue,
        natureName
      };
      if (!this.isshelf) {
        if (this.selectArr.length === 0) {
          this.selectArr.push(target);
        } else {
          let boon = false;
          this.selectArr.forEach((value, indexs) => {
            if (value.id === id) {
              this.selectArr = this.selectArr.filter((e) => e.id !== id);
              boon = true;
            } else if (value.index === index) {
              boon = true;
              this.selectArr[indexs].id = id;
              this.selectArr[indexs].natureValue = natureValue;
              this.selectArr[indexs].natureName = natureName;
            }
          });
          if (!boon) {
            this.selectArr.push(target);
          }
        }
        if (this.selectArr.length === this.naturelist.length) {
          const price = this.priceList.filter(
            (e: any) => e.natureIds.split(',').sort().join(',')
                        === this.selectArr
                          .map((ele: any) => ele.id)
                          .sort()
                          .join(',')
          );
          this.selectPrice = String(price[0].price);
          this.selectMarkPrice = String(price[0].originalPrice);
          this.selectId = price[0].id;
          this.realDiscountStatusly = price[0].realDiscountStatus;
          this.realDiscountPrice = price[0].realDiscountPrice;

          const { mallImage, weight } = this.priceList.filter(
            (e) => e.id === this.selectId
          )[0];

          this.weight = weight;
          if (mallImage?.cdnFilePathH5) {
            this.imgurl = JSON.parse(JSON.stringify(this.imgUrlList));
            this.imgurl = [{ cdnFilePathPc: mallImage?.cdnFilePathH5 }];
            this.mySwiper.activeIndex = this.imgurl.length;
          } else {
            this.imgurl = JSON.parse(JSON.stringify(this.imgUrlList));
            this.mySwiper.activeIndex = 0;
          }
        } else {
          this.selectPrice = '';
          this.selectMarkPrice = '';
          this.selectId = '';
          this.imgurl = JSON.parse(JSON.stringify(this.imgUrlList));
          this.mySwiper.activeIndex = 0;
        }
      }
    }

    // 没有所属规格置灰
    private checkDisabled(id: number, index: number) {
      let flagCheck = false;
      const naturearrCheck = this.priceList.map((e: any) => e.natureIds.split(','));
      if (this.selectArr.length > 0) {
        naturearrCheck.forEach((_item) => {
          let flagSum = 0;
          const lines: any[] = [];
          this.selectArr.forEach((item) => {
            lines.push(item.index);
            if (_item.indexOf(`${item.id}`) !== -1) {
              flagSum += 1;
            }
          });
          if (_item.indexOf(`${id}`) !== -1 && flagSum >= 1) {
            if (
              (flagSum >= this.selectArr.length - 1
                            && lines.indexOf(index) !== -1)
                        || flagSum >= this.selectArr.length
            ) {
              flagCheck = true;
            }
          }
        });
        if (
          flagCheck
                || (this.selectArr.length === 1 && index === this.selectArr[0].index)
        ) {
          return false;
        }

        return true;
      }
      return false;
    }

    // 去分类页
    goClassify() {
      this.$router.push(`/classify?productTypeId=${this.productType}`);
    }

    // 发起砍价
    async startBargain() {
      if (readCookie('accessToken')) {
        if (this.selectArr.length !== this.naturelist.length) {
          this.$message.error('请选择商品属性！');
        } else {
          const res: any = await startBargain({
            configId: this.$route.query.configId,
            productId: this.$route.query.product_id,
            productPriceId: this.selectId,
            companyId: 1
          });
          if (res.data.code === 100) {
            this.$router.push({ name: 'bargain' });
            this.$message.success('申请砍价成功！');
          } else if (res.data.code === 2149) {
            this.$message.error(res.data.message);
          }
        }
      } else {
        this.$router.push({ name: 'login' });
        this.$message.success('请先登录!');
      }
    }

    // 加入购物车
    async addtocard(type: string) {
      const anchor = readCookie('anchor');
      if (readCookie('accessToken')) {
        const maxnum = Math.floor(100000 / Number(this.selectPrice));
        if (this.selectArr.length !== this.naturelist.length) {
          this.$message.error('请选择商品属性！');
        } else if (this.val > maxnum) {
          this.val = maxnum;
          this.maxNum = maxnum;
          this.$message.error(`此规格限购${maxnum}件`);
        } else if (type === 'single') {
          // 自动领取优惠卷
          await auto_receive_coupon({
            productIds: this.$route.query.id,
            companyId: 1
          });

          const productItem: any = {
            productId: this.productlist.id,
            freight: null,
            id: this.selectId,
            mallImage: {
              source_url: this.imgurl[0].cdnFilePathPc,
              product_name: this.productlist.productName
            },
            natureList: this.selectArr,
            num: this.val,
            price: this.selectPrice,
            totalPrice: this.totalPrice
          };
          if (Object.keys(this.giftMap).length > 0) {
            productItem.giftMallImage = this.giftMap;
          }
          const confirmlist = [productItem];
          const { from } = this.$route.query;
          let url;
          if (from === 'classify') {
            url = getDataProType;
          } else if (from === 'carousel') {
            url = getDataBanner;
          } else {
            url = getDataReCommend;
          }
          if (from) {
            url({
              companyId: 1,
              orderNum: '',
              orderStatus: '',
              refundReason: '',
              equip: anchor ? anchor.equip : 4,
              version: anchor ? anchor.version : '',
              src: anchor ? (anchor.src ? anchor.src : 2) : 4,
              model: anchor ? anchor.model : '',
              equipVersion: anchor ? anchor.equipVersion : '',
              equipMeid: anchor ? anchor.equipMeid : '',
              // eslint-disable-next-line no-nested-ternary
              eventNo:
                            from === 'classify'
                              ? '2.3.1.1.0.0.2'
                              : from === 'carousel'
                                ? '2.4.1.0.0.0.2'
                                : from === 'hotlist'
                                  ? '2.5.1.0.0.0.2'
                                  : ''
            });
          }
          this.CONFIRMORDER(confirmlist);
          if (this.$route.query.type) {
            const obj: any = this.exchangeInfo;
            if (obj.ruleType === 2) {
              obj.maxIntegral = _.round(
                _.multiply(
                  _.subtract(
                    Number(this.selectPrice),
                    (this as any).exchangeInfo.discountAmount
                  ),
                  100
                )
              );
            }
            // sessionStorage.setItem('integralInfo', JSON.stringify(obj));
            writeStorage('integralInfo', obj);
          }
          this.$router.push(
            this.$route.query.from
              ? `/orderconfirm?type=2&from=${this.$route.query.from}`
              : '/orderconfirm?type=2'
          );
        } else {
          const res: any = await addCart({
            productPriceId: this.selectId,
            num: this.val,
            equip: anchor ? anchor.equip : '',
            version: anchor ? anchor.version : '',
            companyId: 1
          });
          if (res.data.code === 100) {
            const { from } = this.$route.query;
            let url;
            if (from === 'classify') {
              url = getDataProType;
            } else if (from === 'carousel') {
              url = getDataBanner;
            } else {
              url = getDataReCommend;
            }
            if (from) {
              url({
                companyId: 1,
                orderNum: '',
                orderStatus: '',
                refundReason: '',
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                src: anchor ? (anchor.src ? anchor.src : 2) : 4,
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : '',
                // eslint-disable-next-line no-nested-ternary
                eventNo:
                                from === 'classify'
                                  ? '2.3.1.1.0.0.1'
                                  : from === 'carousel'
                                    ? '2.4.1.0.0.0.1'
                                    : from === 'hotlist'
                                      ? '2.5.1.0.0.0.1'
                                      : ''
              });
            }
            this.$message.success('加入购物车成功');
            this.setCardNum();
            this.setWhiteStauts();
          } else {
            this.$message.error(res.data.message);
          }
        }
      } else {
        this.$router.push({
          name: 'login',
          query: {
            redirect: this.$route.fullPath
          }
        });
      }
    }

    // 选择地址
    selectAddress() {
      this.isAddressSelect = !this.isAddressSelect;
    }

    confirmAddress(item: any, index: number) {
      this.address = `${item.provinceName}${item.cityName}${item.areaName}`;
      this.addressid = item.id;
      this.addIndex = index;
      this.isAddressSelect = false;
    }

    // 新增地址
    openAdd() {
      this.options = addData.data;
      this.value = [];
      this.showDialogBack = true;
      this.$nextTick(() => {
        const form = this.$refs.ruleForm as any;
        form.resetFields();
        this.ruleForm = {
          realName: '',
          cityId: '',
          cityName: '',
          areaId: '',
          areaName: '',
          address: '',
          area: '',
          telephone: '',
          defaultAddress: 0,
          provinceId: '',
          provinceName: '',
          addressTemp: ''
        };
      });
    }

    // 选择省份
    chooseProvince(id: number) {
      this.ruleForm.provinceName = this.options.filter(
        (e) => e.value === id
      )[0].label;
      this.ruleForm.cityId = this.options.filter(
        (e) => e.value === id
      )[0].children[0].value;
      this.ruleForm.cityName = this.options.filter(
        (e) => e.value === id
      )[0].children[0].label;
      this.cityOptions = this.options.filter((e) => e.value === id)[0].children;
      this.areaOptions = this.cityOptions.filter(
        (e) => e.value === this.ruleForm.cityId
      )[0].children;
      this.ruleForm.areaId = this.cityOptions.filter(
        (e) => e.value === this.ruleForm.cityId
      )[0].children[0].value;
      this.ruleForm.areaName = this.cityOptions.filter(
        (e) => e.value === this.ruleForm.cityId
      )[0].children[0].label;
      this.$nextTick(() => {
        (this as any).$refs.ruleForm.clearValidate('areaId');
      });
    }

    // 选择市
    chooseCity(id: number) {
      this.ruleForm.cityName = this.cityOptions.filter(
        (e) => e.value === id
      )[0].label;
      this.areaOptions = this.cityOptions.filter(
        (e) => e.value === id
      )[0].children;
      this.ruleForm.areaId = this.cityOptions.filter(
        (e) => e.value === id
      )[0].children[0].value;
      this.ruleForm.areaName = this.cityOptions.filter(
        (e) => e.value === id
      )[0].children[0].label;
      this.$nextTick(() => {
        (this as any).$refs.ruleForm.clearValidate('areaId');
      });
    }

    // 选择区
    chooseArea(id: number) {
      this.ruleForm.areaName = this.areaOptions.filter(
        (e) => e.value === id
      )[0].label;
      this.$nextTick(() => {
        (this as any).$refs.ruleForm.clearValidate('areaId');
      });
    }

    private async addressLists() {
      if (readCookie('accessToken')) {
        this.addressList = [];
        const res: any = await addressList({
          pageNo: 1,
          pageSize: 20
        });
        this.receiveAddress = res.data.data.filter(
          (e: any) => e.defaultAddress === 1
        );
        this.addressList = res.data.data;
        if (this.addressList.length !== 0) {
          this.address = `${this.addressList[0].provinceName}${this.addressList[0].cityName}${this.addressList[0].areaName}`;
          this.addressid = this.addressList[0].id;
        }
      }
    }

    // 确认新增地址
    private async createData() {
      const form = this.$refs.ruleForm as any;
      form.validate(async (valid: boolean) => {
        if (valid) {
          this.ruleForm.address = this.ruleForm.provinceName
                    + this.ruleForm.cityName
                    + this.ruleForm.areaName
                    + this.ruleForm.addressTemp;
          const res: any = await saveAddress(this.ruleForm);
          if (res.data.code === 100) {
            this.addressList = [];
            this.showDialogBack = false;
            const response: any = await addressList({
              pageNo: 1,
              pageSize: 20
            });
            this.addressList = response.data.data;
            if (this.receiveAddress.some((e: any) => e.defaultAddress === 1)) {
              if (
                this.addressList.filter((e: any) => e.defaultAddress === 1)[0]
                  .id === this.receiveAddress[0].id
              ) {
                this.address = `${this.addressList[1].provinceName}${this.addressList[1].cityName}${this.addressList[1].areaName}`;
                this.addressid = this.addressList[1].id;
              } else {
                this.address = `${this.addressList[0].provinceName}${this.addressList[0].cityName}${this.addressList[0].areaName}`;
                this.addressid = this.addressList[0].id;
              }
            } else {
              this.address = `${this.addressList[0].provinceName}${this.addressList[0].cityName}${this.addressList[0].areaName}`;
              this.addressid = this.addressList[0].id;
            }
            this.isAddressSelect = false;
            this.$message.success('添加成功');
          } else {
            this.$message.error(res.data.message);
          }
        }
      });
    }

    // 计算运费
    private async getFreight() {
      let res: any = {};
      if (this.$route.query.type === 'integral') {
        // 积分兑换
        res = await getFreight({
          addressId: this.addressid,
          productPriceId: this.selectId,
          configId: (this as any).exchangeInfo.id,
          num: 1,
          type: 3,
          companyId: 1
        });
      } else if (this.$route.query.type === 'bargain') {
        // 砍价
        res = await getFreight({
          addressId: this.addressid,
          productPriceId: this.selectId,
          configId: (this as any).bargainInfo.id,
          num: 1,
          type: 4,
          companyId: 1
        });
      } else {
        res = await getFreight({
          companyId: 1,
          addressId: this.addressid,
          cartIds: '',
          orderNo: '',
          productPriceId: this.selectId,
          num: this.val,
          type: 2
        });
      }
      if (res.data.data > 0) {
        this.freightPrice = `¥${res.data.data}`;
      } else if (res.data.data === 0 || res.data.data === 0.0) {
        this.freightPrice = '包邮';
      }
      this.hangcChange(1);
    }

    handleSizeChange(pageSize: number) {
      this.pageSize = pageSize;
      this.getEvaList();
    }

    handleCurrentChange(pageNo: number) {
      this.pageNo = pageNo;
      this.getEvaList();
    }

    // 访问页面数据埋点
    private pageVisit() {
      const anchor = readCookie('anchor');
      pageVisit({
        pageType: 3,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? (anchor.src ? anchor.src : 2) : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        companyId: 1
      });
    }

    // 查询开屏推广图片
    private async getPopularizeList() {
      const res: any = await popularizeList({
        showPostion: 2,
        companyId: 1
      });
      this.isFLash = res.data.data.length !== 0 && res.data.data[0].pcSourceUrl !== '';
      if (res.data.data.length !== 0) {
        this.appSourceUrl = res.data.data[0].pcSourceUrl;
        this.flashSaleId = res.data.data[0].id;
        if (this.appSourceUrl === '') {
          this.smallSourceUrl = res.data.data[0].smallSourceUrl;
        } else {
          this.smallSourceUrl = '';
        }
      } else {
        this.appSourceUrl = '';
        this.flashSaleId = '';
        this.smallSourceUrl = '';
      }
    }

    // 领取开屏推广
    private async popularizeReceive(str?: string) {
      const res: any = await popularizeReceive({
        id: this.flashSaleId,
        companyId: 1
      });
      if (res.data.code === 100) {
        this.getPopularizeList();
        if (str === 'isFlash') {
          this.isFLash = false;
        }
        (this as any).$message.success('领取成功！');
      } else {
        this.$message.error(res.data.message);
      }
    }

    // 关闭开屏推广
    async closeSale() {
      this.isFLash = false;
      await popularizeClose({ id: this.flashSaleId });
      await this.getPopularizeList();
    }
}
